/** Per-photo result of an `all_images` fan-out. */
export interface BatchItem {
  ringImageId: string;
  sourceUrl: string;
  status: string; // complete | rejected | in_review | noop | error | accepted | …
  url?: string | undefined;
  error?: string | undefined;
}

/** A thumbnail grid of all-images results — one tile per registered photo, showing its outcome. */
export function BatchGrid({ items }: { items: BatchItem[] }) {
  return (
    <div className="lab-batch">
      {items.map((it) => (
        <figure key={it.ringImageId}>
          <img src={it.url || it.sourceUrl} alt={it.status} />
          <figcaption className={`s-${it.status}`}>
            {it.status}
            {it.error ? ` · ${it.error}` : ""}
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
